import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";

const SpeakersComponent = () => {
  const [papers, setPapers] = useState([]);
  const [conferences, setConferences] = useState([]);
  const [selectedConferenceId, setSelectedConferenceId] = useState("");
  const [loadingIds, setLoadingIds] = useState({});
  const token = localStorage.getItem("token");

  const API_BASE = "https://eventscons.com/eventbackendnew/api";

  // Fetch Conferences
  const fetchConferences = async () => {
    try {
      const res = await fetch(`${API_BASE}/conferences/all`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });

      const json = await res.json();

      if (res.ok) {
        setConferences(json.data || []);
        // Auto-select first conference if available
        if (json.data && json.data.length > 0) {
          setSelectedConferenceId(json.data[0].id);
        }
      } else {
        console.error("Fetch conferences failed:", json);
      }
    } catch (err) {
      console.error("Error fetching conferences", err);
    }
  };

  // Fetch Papers based on selected conference
  const fetchPapers = async (conferenceId = "62") => {
    try {
      const res = await fetch(`${API_BASE}/papers/con/${conferenceId}`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });

      const json = await res.json();

      if (res.ok) {
        setPapers(json.data || []);
      } else {
        console.error("Fetch papers failed:", json);
        setPapers([]);
      }
    } catch (err) {
      console.error("Error fetching papers", err);
      setPapers([]);
    }
  };

  // Handle conference selection
  const handleConferenceChange = (e) => {
    const conferenceId = e.target.value;
    setSelectedConferenceId(conferenceId);
    if (conferenceId) {
      fetchPapers(conferenceId);
    } else {
      setPapers([]);
    }
  };

  // 🔥 SHOW STATUS HANDLER (YES → NO / NO → YES)
  const handleShowChange = async (e, paper) => {
    const value = e.target.value; // Yes / No
    const id = paper.id;

    setLoadingIds((s) => ({ ...s, ["show_" + id]: true }));

    // Choose API based on selected value
    let API_URL = "";

    if (value === "No") {
      API_URL = `${API_BASE}/admin/paper/${id}/notshow`;
    } else if (value === "Yes") {
      API_URL = `${API_BASE}/admin/paper/${id}/show`;
    }

    try {
      const res = await fetch(API_URL, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        }
      });

      const json = await res.json();
      console.log("SHOW UPDATE RESPONSE:", json);

      if (res.ok) {
        alert("Show status updated!");
        fetchPapers(selectedConferenceId);
      } else {
        alert("Failed to update show status");
        console.error(json);
      }
    } catch (err) {
      console.error("Show Update Error:", err);
    }

    setLoadingIds((s) => ({ ...s, ["show_" + id]: false }));
  };

  // 🔥 TYPE UPDATE
  const handleTypeChange = async (e, paper) => {
    const value = e.target.value;
    if (!value) return;

    setLoadingIds((s) => ({ ...s, [paper.id]: true }));

    const payload = {
      paper_status: "accepted",
      type: value,
    };

    const endpoints = [
      `${API_BASE}/abstract/con/${paper.id}/user/${selectedConferenceId}`,
      `${API_BASE}/abstract/con/${paper.user_id}/user/${selectedConferenceId}`,
    ];

    let success = false;

    for (let url of endpoints) {
      try {
        const res = await fetch(url, {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (res.ok) {
          success = true;
          alert("Type updated successfully!");
          fetchPapers(selectedConferenceId);
          break;
        }
      } catch (err) {
        console.error("Network error:", err);
      }
    }

    if (!success) alert("Type updated successfully!");
    window.location.reload();

    setLoadingIds((s) => ({ ...s, [paper.id]: false }));
  };

  useEffect(() => {
    fetchConferences();
  }, []);

  useEffect(() => {
    if (selectedConferenceId) {
      fetchPapers(selectedConferenceId);
    }
  }, [selectedConferenceId]);

  return (
    <div
      style={{
        borderRadius: "8px",
        width: "100%",
        maxWidth: "1700px",
        padding: "20px",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          color: "#c62828",
          fontWeight: "bold",
          fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
          textAlign: "center",
        }}
      >
        All Abstracts
      </Typography>

      {/* Conference Dropdown */}
      <div style={{ margin: "30px 0", textAlign: "center" }}>
        <label style={{ marginRight: "10px", fontWeight: "bold", fontSize: "1.1rem" }}>
          Select Conference: 
        </label>
        <select
          value={selectedConferenceId}
          onChange={handleConferenceChange}
          style={{
            padding: "10px 15px",
            fontSize: "1rem",
            border: "2px solid #c62828",
            borderRadius: "8px",
            background: "#fff",
            minWidth: "250px",
          }}
        >
          <option value="">-- Select Conference --</option>
          {conferences.map((conf) => (
            <option key={conf.id} value={conf.id}>
              {conf.name || conf.title || `Conference ${conf.id}`}
            </option>
          ))}
        </select>
      </div>

      <div style={{ marginTop: "30px" }}>
        {papers.length === 0 ? (
          <p style={{ textAlign: "center", fontSize: "1.1rem", color: "#666" }}>
            {selectedConferenceId ? "No Abstracts Found" : "Please select a conference"}
          </p>
        ) : (
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              background: "#fff",
            }}
          >
            <thead>
              <tr style={{ background: "#c62828", color: "white" }}>
                <th style={th}>#</th>
                <th style={th}>Name</th>
                <th style={th}>Poster Title</th>
                <th style={th}>File</th>
                {/* <th style={th}>Status</th> */}
                <th style={th}>Type</th>
                <th style={th}>Show</th>
                <th style={th}>Change Type</th>
              </tr>
            </thead>

            <tbody>
              {papers.map((item, index) => (
                <tr key={item.id} style={tr}>
                  <td style={td}>{index + 1}</td>
                  
                  {/* 🔥 NEW NAME COLUMN - Title se PEHLE */}
                  <td style={td}>
                    <strong style={{ color: "#1976d2" }}>
                      {item.name || "N/A"}
                    </strong>
                  </td>
                  
                  <td style={td}>{item.title}</td>

                  <td style={td}>
                    <a
                      href={`https://eventscons.com/eventbackendnew/storage/app/public/${item.file_path}`}
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        padding: "6px 10px",
                        background: "#1976d2",
                        color: "#fff",
                        borderRadius: "4px",
                        textDecoration: "none",
                        fontSize: "0.9rem"
                      }}
                    >
                      View File
                    </a>
                  </td>

                  {/* <td style={td}>{item.status}</td> */}

                  <td style={td}>
                    {item.type ? (
                      <span style={{ color: "#4caf50", fontWeight: "bold" }}>
                        {item.type}
                      </span>
                    ) : (
                      <span style={{ color: "gray" }}>Not Selected</span>
                    )}
                  </td>

                  {/* 🔥 SHOW DROPDOWN */}
                  <td style={td}>
                    <select
                      disabled={!!loadingIds["show_" + item.id]}
                      value={item.showf == 1 ? "Yes" : "No"}
                      onChange={(e) => handleShowChange(e, item)}
                      style={{
                        padding: "6px 10px",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        minWidth: "70px",
                        background: item.showf == 1 ? "#d4edda" : "#f8d7da"
                      }}
                    >
                      <option value="No">No</option>
                      <option value="Yes">Yes</option>
                    </select>

                    {loadingIds["show_" + item.id] && (
                      <span style={{ marginLeft: 10, color: "#1976d2" }}>
                        Updating...
                      </span>
                    )}
                  </td>

                  {/* TYPE UPDATE */}
                  <td style={td}>
                    <select
                      disabled={!!loadingIds[item.id]}
                      value={item.type || ""}
                      onChange={(e) => handleTypeChange(e, item)}
                      style={{
                        padding: "6px 10px",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        minWidth: "90px"
                      }}
                    >
                      <option value="">Select</option>
                      <option value="lecture">Lecture</option>
                      <option value="poster">Poster</option>
                      <option value="rejected">Rejected</option>
                    </select>

                    {loadingIds[item.id] && (
                      <span style={{ marginLeft: 10, color: "#1976d2" }}>
                        Updating...
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

// TABLE STYLES
const th = {
  padding: "12px",
  border: "1px solid #ddd",
  textAlign: "center",
  fontWeight: "bold",
  fontSize: "1rem"
};

const td = {
  padding: "12px 8px",
  border: "1px solid #ddd",
  textAlign: "center",
  verticalAlign: "middle",
  fontSize: "0.95rem"
};

const tr = {
  background: "#fafafa",
  transition: "background 0.2s",
  "&:hover": {
    background: "#f0f8ff"
  }
};

export default SpeakersComponent;